module.exports = __webpack_public_path__ + "static/media/web.69ecc4fd.svg";